import { Autocomplete, CircularProgress, TextField, Card, Chip, Grid, Icon, IconButton, InputLabel, Tooltip, Checkbox, FormControlLabel, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDSelect from "components/MDSelect";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useUser } from "context/UserContext";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import { useCallback, useEffect, useRef, useState } from "react";
import { toDateTime } from "utils/DateUtils";
import { cleanFormatCNPJ } from "utils/Functions";
import { post, get, postNoResponse } from "utils/WebService";
import BaseDeDadosCreateEdit from "./BaseDeDadosCreateEdit";
import MDSnackbar from "components/MDSnackbar";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

export default function BaseDeDadosConsult() {

    const { processoStatus, userFunctionalities, userPerfils } = useUser();
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const isLiberado = userPerfils?.some(p => {
        const n = p.ccNome?.toLowerCase() || '';
        return n.includes("gestor") || n.includes("admin") || n.includes("coord");
    });
    const hideFaseFilter = !isLiberado;

    const faseOptions = [
        { id: null, nome: "Ambas" },
        { id: false, nome: "Extrajudicial" },
        { id: true, nome: "Jurídica" }
    ];

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: [],
        cvId: "",
        nome: "",
        cpfCnpj: "",
        codigoCliente: "",
        status: null,
        idUsuario: null,
        fase: null,
        hideDevolvidos: false,
    });

    const [data, setData] = useState([]);
    const [pages, setPages] = useState(0);
    const [loadingTable, setLoadingTable] = useState(false);
    const [isCreateEdit, setIsCreateEdit] = useState(false);
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [isJuridicoForm, setIsJuridicoForm] = useState(false);

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [devedorToDelete, setDevedorToDelete] = useState(null);
    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [sbMessage, setSbMessage] = useState("");

    const [filters, setFilters] = useState({
        cvId: "",
        nome: "",
        cpfCnpj: "",
        codigoCliente: "",
        status: null,
        idUsuario: null,
        fase: faseOptions[0],
        hideDevolvidos: false,
        cliente: null,
    });

    const [pessoaOptions, setPessoaOptions] = useState([]);
    const [loadingPessoas, setLoadingPessoas] = useState(false);
    const searchTimeout = useRef(null);
    const handleSearchPessoas = (val) => {
        if (searchTimeout.current) clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            setLoadingPessoas(true);
            get(`/pessoa/list-all?search=${val || ""}`).then(({ list }) => {
                setPessoaOptions(list || []);
                setLoadingPessoas(false);
            }).catch(() => setLoadingPessoas(false));
        }, 500);
    };

    useEffect(() => {
        handleSearchPessoas("");
    }, []);

    useEffect(() => {
        const pendingId = sessionStorage.getItem('pendingDevedorId');
        if (pendingId) {
            sessionStorage.removeItem('pendingDevedorId');
            setSelectedId(pendingId);
            setIsViewOnly(true);
            setIsCreateEdit(true);
        }
    }, []);

    const [statusFichaOptions, setStatusFichaOptions] = useState([]);
    const [usuariosOptions, setUsuariosOptions] = useState([]);

    useEffect(() => {
        get("/status-ficha/list-all").then((res) => {
            setStatusFichaOptions(res.list || res.data || (Array.isArray(res) ? res : []));
        }).catch(() => {});

        get(`/users/list-all-operators`).then((res) => {
            setUsuariosOptions(res.list || res.data || (Array.isArray(res) ? res : []));
        }).catch(() => {});
    }, []);

    const [recordsTotal, setRecordsTotal] = useState(0);

    const fetchData = useCallback(({ pageSize, pageIndex, sorting, filtered, cvId, nome, cpfCnpj, codigoCliente, titulo, processo, status, idUsuario, fase, hideDevolvidos, cliente }) => {
        setLoadingTable(true);
        const updatedTableState = {
            pageSize: pageSize ? pageSize : tableState.current.pageSize,
            pageIndex: (pageIndex == 0 || pageIndex) ? pageIndex : tableState.current.pageIndex,
            sorting: sorting ? sorting : tableState.current.sorting,
            filtered: filtered ? filtered : tableState.current.filtered,
            cvId: cvId !== undefined ? cvId : tableState.current.cvId,
            nome: nome !== undefined ? nome : tableState.current.nome,
            cpfCnpj: cpfCnpj !== undefined ? cpfCnpj : tableState.current.cpfCnpj,
            codigoCliente: codigoCliente !== undefined ? codigoCliente : tableState.current.codigoCliente,
            titulo: titulo !== undefined ? titulo : tableState.current.titulo,
            processo: processo !== undefined ? processo : tableState.current.processo,
            status: status !== undefined ? status : tableState.current.status,
            idUsuario: idUsuario !== undefined ? idUsuario : tableState.current.idUsuario,
            fase: fase !== undefined ? fase : tableState.current.fase,
            hideDevolvidos: hideDevolvidos !== undefined ? hideDevolvidos : tableState.current.hideDevolvidos,
            cliente: cliente !== undefined ? cliente : tableState.current.cliente,
        };

        tableState.current = updatedTableState;

        post("/devedor/list", {
            page: updatedTableState.pageIndex,
            pageSize: updatedTableState.pageSize,
            sorted: updatedTableState.sorting,
            cvId: updatedTableState.cvId ? parseInt(updatedTableState.cvId) : null,
            ccNome: updatedTableState.nome,
            ccDocumento: updatedTableState.cpfCnpj,
            ccCodigoCliente: updatedTableState.codigoCliente,
            ccTitulo: updatedTableState.titulo,
            ccProcesso: updatedTableState.processo,
            idStatusFicha: updatedTableState.status,
            idUsuario: updatedTableState.idUsuario,
            hideDevolvidos: updatedTableState.hideDevolvidos,
            idPessoa: updatedTableState.cliente ? updatedTableState.cliente.id : null,

        }).then(({ data, pages, recordsTotal }) => {
            setData(data || []);
            setPages(pages || 0);
            setRecordsTotal(recordsTotal || 0);
            setLoadingTable(false);
        }).catch(() => {
            setLoadingTable(false);
        });

    }, []);

    useEffect(() => {
        fetchData(tableState.current);
    }, [fetchData]);

    const handleCreate = () => {
        if (!hideFaseFilter && filters.fase?.id === null) {
            alert("Por favor, selecione uma Fase (Extrajudicial ou Jurídica) no filtro para criar um novo cadastro.");
            return;
        }

        let faseId = filters.fase?.id;
        if (hideFaseFilter) {
            const isJuridicoProfile = userPerfils?.some(p => p.ccNome?.toLowerCase().includes("jur") && !p.ccNome?.toLowerCase().includes("extra"));
            faseId = isJuridicoProfile ? true : false;
        }

        setIsJuridicoForm(faseId);
        setSelectedId(null);
        setIsCreateEdit(true);
    };

    const backFunction = () => {
        setIsCreateEdit(false);
        setSelectedId(null);
        fetchData(tableState.current);
    };

    const handleDeleteClick = (row) => {
        setDevedorToDelete(row);
        setDeleteDialogOpen(true);
    };

    const confirmDelete = () => {
        if (!devedorToDelete) return;
        postNoResponse("/devedor/delete", { id: devedorToDelete.id })
            .then(() => {
                setSbMessage("Devedor excluído com sucesso!");
                setSuccessSB(true);
                fetchData(tableState.current);
            })
            .catch(() => {
                setSbMessage("Erro ao excluir devedor. Verifique se existem vínculos.");
                setErrorSB(true);
            })
            .finally(() => {
                setDeleteDialogOpen(false);
                setDevedorToDelete(null);
            });
    };

    const userColumns = [
        {
            header: "Cód. Cliente",
            accessorKey: "codigoCliente",
            cell: info => <DefaultCell>{info.row.original.status === 1 ? <MDTypography variant="caption" color="error" fontWeight="medium">{info.getValue() || '-'}</MDTypography> : (info.getValue() || '-')}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Cliente",
            accessorKey: "nomeCliente",
            cell: info => <DefaultCell>{info.row.original.status === 1 ? <MDTypography variant="caption" color="error" fontWeight="medium">{info.getValue() || '-'}</MDTypography> : (info.getValue() || '-')}</DefaultCell>,
            isSorted: false
        },
        {
            header: "Nome",
            accessorKey: "nome",
            cell: info => <DefaultCell>{info.row.original.status === 1 ? <MDTypography variant="caption" color="error" fontWeight="medium">{info.getValue() || '-'}</MDTypography> : (info.getValue() || '-')}</DefaultCell>,
            isSorted: true
        },
        {
            header: "CPF/CNPJ",
            accessorKey: "cpfCnpj",
            cell: info => <DefaultCell>{info.row.original.status === 1 ? <MDTypography variant="caption" color="error" fontWeight="medium">{info.getValue() || '-'}</MDTypography> : (info.getValue() || '-')}</DefaultCell>,
            isSorted: true
        },
        {
            header: "Status",
            accessorKey: "statusFichaNome",
            cell: info => {
                const isDevolvido = info.row.original.status === 1;
                const displayValue = info.getValue() || info.row.original.status || "-";
                
                if (isDevolvido) {
                    return (
                        <DefaultCell>
                            <MDTypography variant="caption" color="error" fontWeight="bold">
                                {displayValue} (Devolvido)
                            </MDTypography>
                        </DefaultCell>
                    );
                }
                
                return <DefaultCell>{displayValue}</DefaultCell>;
            },
            isSorted: true
        },
        {
            header: "ações",
            isSorted: false,
            cell: info => (
                <MDBox display="flex">
                    {userFunctionalities?.includes("c050_V") && (
                        <Tooltip title="Visualizar Cadastro">
                            <IconButton
                                onClick={() => {
                                    setSelectedId(info.row.original.id);
                                    setIsViewOnly(true);
                                    setIsCreateEdit(true);
                                }}>
                                <MDTypography variant="h5">
                                    <Icon color="info">visibility</Icon>
                                </MDTypography>
                            </IconButton>
                        </Tooltip>
                    )}
                    {userFunctionalities?.includes("c050_U") && (
                        <Tooltip title="Editar Cadastro">
                            <IconButton
                                onClick={() => {
                                    setSelectedId(info.row.original.id);
                                    setIsViewOnly(false);
                                    setIsCreateEdit(true);
                                }}>
                                <MDTypography variant="h5">
                                    <Icon color="warning">edit</Icon>
                                </MDTypography>
                            </IconButton>
                        </Tooltip>
                    )}
                    {userFunctionalities?.includes("c050_D") && (
                        <Tooltip title="Excluir Devedor">
                            <IconButton onClick={() => handleDeleteClick(info.row.original)}>
                                <MDTypography variant="h5">
                                    <Icon color="error">delete</Icon>
                                </MDTypography>
                            </IconButton>
                        </Tooltip>
                    )}
                </MDBox>
            ),
            width: "10%"
        },
    ];

    const handleApplyFilter = () => {
        fetchData({
            ...tableState.current,
            cvId: filters.cvId,
            nome: filters.nome,
            cpfCnpj: cleanFormatCNPJ(filters.cpfCnpj),
            codigoCliente: filters.codigoCliente,
            titulo: filters.titulo,
            processo: filters.processo,
            status: filters.status?.id,
            idUsuario: filters.idUsuario?.id,
            fase: filters.fase?.id,
            hideDevolvidos: filters.hideDevolvidos,
            cliente: filters.cliente,
            pageIndex: 0
        });
    };

    const handleCleanFilter = () => {
        setFilters({
            cvId: "",
            nome: "",
            cpfCnpj: "",
            codigoCliente: "",
            titulo: "",
            processo: "",
            status: null,
            idUsuario: null,
            fase: faseOptions[0],
            hideDevolvidos: false,
            cliente: null,
        });
        const updatedTableState = {
            pageSize: 10,
            pageIndex: 0,
            sorting: [],
            filtered: [],
            cvId: "",
            nome: "",
            cpfCnpj: "",
            codigoCliente: "",
            titulo: "",
            processo: "",
            status: null,
            idUsuario: null,
            fase: null,
            hideDevolvidos: false,
            cliente: null,
        };
        tableState.current = updatedTableState;
        fetchData(updatedTableState);
    };

    return (
        <Grid container display="flex" justifyContent="center">
            {isCreateEdit &&
                <Grid item xs={12} md={12}>
                    <BaseDeDadosCreateEdit recordId={selectedId} closeCreateEdit={backFunction} isJuridico={isJuridicoForm} isViewOnly={isViewOnly} />
                </Grid>
            }
            <Grid item xs={12} md={12} sx={{ display: isCreateEdit ? "none" : "" }}>
                <Card
                    variant="outlined"
                    sx={{
                        px: 2,
                        py: 1.5,
                        mb: 2,
                        background: darkMode ? "#23233a" : "#fafafa",
                        borderColor: darkMode ? "#333" : "#ddd",
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={2}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>ID</InputLabel>
                            <MDInput
                                size="small"
                                placeholder="Digite o ID..."
                                value={filters.cvId ?? ""}
                                onChange={(e) => setFilters({ ...filters, cvId: e.target.value })}
                                onKeyDown={(e) => { if (e.key === 'Enter') handleApplyFilter(); }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Nome</InputLabel>
                            <MDInput
                                size="small"
                                placeholder="Digite o nome..."
                                value={filters.nome ?? ""}
                                onChange={(e) => setFilters({ ...filters, nome: e.target.value })}
                                onKeyDown={(e) => { if (e.key === 'Enter') handleApplyFilter(); }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>CPF/CNPJ</InputLabel>
                            <MDInput
                                size="small"
                                placeholder="Digite o CPF/CNPJ..."
                                value={filters.cpfCnpj ?? ""}
                                onChange={(e) => setFilters({ ...filters, cpfCnpj: e.target.value })}
                                onKeyDown={(e) => { if (e.key === 'Enter') handleApplyFilter(); }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Cód. Cliente</InputLabel>
                            <MDInput
                                size="small"
                                placeholder="Informe o código..."
                                value={filters.codigoCliente ?? ""}
                                onChange={(e) => setFilters({ ...filters, codigoCliente: e.target.value })}
                                onKeyDown={(e) => { if (e.key === 'Enter') handleApplyFilter(); }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Cliente</InputLabel>
                            <Autocomplete
                                options={pessoaOptions}
                                filterOptions={(x) => x}
                                getOptionLabel={(option) => {
                                    if (typeof option === 'string') return option;
                                    return option.nomeComum || option.nomeCompleto || "";
                                }}
                                onInputChange={(e, val) => handleSearchPessoas(val)}
                                onChange={(e, val) => setFilters({ ...filters, cliente: val })}
                                value={filters.cliente || null}
                                loading={loadingPessoas}
                                renderInput={(params) => (
                                    <MDInput
                                        {...params}
                                        size="small"
                                        placeholder="Buscar cliente..."
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {loadingPessoas ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Título</InputLabel>
                            <MDInput
                                size="small"
                                placeholder="Informe o título..."
                                value={filters.titulo ?? ""}
                                onChange={(e) => setFilters({ ...filters, titulo: e.target.value })}
                                onKeyDown={(e) => { if (e.key === 'Enter') handleApplyFilter(); }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Processo</InputLabel>
                            <MDInput
                                size="small"
                                placeholder="Informe o processo..."
                                value={filters.processo ?? ""}
                                onChange={(e) => setFilters({ ...filters, processo: e.target.value })}
                                onKeyDown={(e) => { if (e.key === 'Enter') handleApplyFilter(); }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Status</InputLabel>
                            <MDSelect
                                isMulti={false}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.ccNome}
                                name="status"
                                placeholder="Ambos"
                                value={filters.status || null}
                                options={statusFichaOptions}
                                onChange={(value) => {
                                    setFilters({ ...filters, status: value })
                                }}
                            />
                        </Grid>
                        {!hideFaseFilter && (
                            <Grid item xs={12} sm={2}>
                                <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Fase</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nome}
                                    name="fase"
                                    placeholder="Ambas"
                                    value={filters.fase || null}
                                    options={faseOptions}
                                    onChange={(value) => {
                                        setFilters({ ...filters, fase: value })
                                    }}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12} sm={2}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Responsável</InputLabel>
                            <MDSelect
                                isMulti={false}
                                getOptionValue={(option) => option.id}
                                getOptionLabel={(option) => option.nome}
                                name="idUsuario"
                                placeholder="Ambos"
                                value={filters.idUsuario || null}
                                options={usuariosOptions}
                                onChange={(value) => {
                                    setFilters({ ...filters, idUsuario: value })
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} display="flex" alignItems="flex-end" pb={0.5}>
                            <FormControlLabel 
                                control={
                                    <Switch 
                                        checked={Boolean(filters.hideDevolvidos)}
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            setFilters((prev) => ({ ...prev, hideDevolvidos: isChecked }));
                                            fetchData({
                                                ...tableState.current,
                                                hideDevolvidos: isChecked,
                                                pageIndex: 0
                                            });
                                        }}
                                        color="info"
                                    />
                                } 
                                label={<MDTypography variant="button" fontWeight="regular" color="text" sx={{ cursor: "pointer", userSelect: "none", ml: -0.5 }}>Exceto Devolvidos</MDTypography>}
                                sx={{ margin: 0 }}
                            />
                        </Grid>
                        
                        <Grid item xs={12} display="flex" alignItems="center" justifyContent="end" pt={1}>
                            <MDBox>
                                <MDButton
                                    size="medium"
                                    sx={{ marginRight: 2 }}
                                    variant="contained"
                                    color="info"
                                    onClick={handleCleanFilter}>
                                    Limpar filtro
                                </MDButton>
                                <MDButton 
                                    size="medium" 
                                    sx={{ marginRight: 2 }}
                                    variant="contained" 
                                    color="info" 
                                    onClick={handleApplyFilter}>
                                    Aplicar filtro
                                </MDButton>
                                {userFunctionalities?.includes("c050_C") && (
                                    <MDButton 
                                        variant="gradient" 
                                        color="success" 
                                        onClick={handleCreate}>
                                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                        &nbsp;NOVO CADASTRO
                                    </MDButton>
                                )}
                            </MDBox>
                        </Grid>
                    </Grid>
                </Card>
                <DataTable
                    loading={loadingTable}
                    columnData={userColumns}
                    data={data}
                    fetchData={fetchData}
                    totalPages={pages}
                    totalRecords={recordsTotal}
                    tableState={tableState} 
                />
            </Grid>

            <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
                <DialogTitle>Confirmar Exclusão</DialogTitle>
                <DialogContent>
                    Tem certeza que deseja excluir o devedor <strong>{devedorToDelete?.nome}</strong>?
                    <br/><br/>
                    <MDTypography variant="caption" color="error">
                        Atenção: Esta ação não poderá ser desfeita.
                    </MDTypography>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setDeleteDialogOpen(false)} color="secondary">
                        Cancelar
                    </MDButton>
                    <MDButton onClick={confirmDelete} color="error" variant="contained">
                        Excluir
                    </MDButton>
                </DialogActions>
            </Dialog>

            <MDSnackbar
                color={successSB ? "success" : "error"}
                icon={successSB ? "check" : "warning"}
                title={successSB ? "Sucesso" : "Erro"}
                content={sbMessage}
                dateTime=""
                open={successSB || errorSB}
                onClose={() => {
                    setSuccessSB(false);
                    setErrorSB(false);
                }}
                close={() => {
                    setSuccessSB(false);
                    setErrorSB(false);
                }}
                bgWhite
            />
        </Grid>
    );
}
